export default "__VITE_ASSET__BZ$chRhc__"